import { useEffect, useState } from "react";
import { getpermissions, getuserdata } from "../services/apiService";

const useUserPermissions = () => {
    const [userPermissions, setUserPermissions] = useState([]);
    const [userData, setUserData] = useState(null);

    useEffect(() => {
        getUserPermissions();
        getUserData();
    }, []);

    const getUserPermissions = async () => {
        const response = await getpermissions();
        console.log("response getuserdata settings:", response);
        setUserPermissions(response);
    };

    const getUserData = async () => {
        const response = await getuserdata('full');
        console.log("response getuserdata settings:", response);
        setUserData(response);
    };

    const hasSiteSettingsPermission = ({ key, type = "" }) => {
        console.log("hasSiteSettingsPermission userPermissions:", userPermissions);
        console.log("hasSiteSettingsPermission key:", key);
        console.log("hasSiteSettingsPermission userData.user_type:", userData?.user_type);
    
        // Admin override
        if (userData?.user_type === "administrator" || userPermissions === "administrator") {
            if(type === "local"){
                return false;
            }
            return true;
        }
    
        // Validate permissions array
        if (!Array.isArray(userPermissions)) {
            console.warn("Invalid userPermissions:", userPermissions);
            return false;
        }
    
        // If type = "global", check both key match and global true
        if (type === "global") {
            const hasGlobalPermission = userPermissions.some(
                permission => permission.value === key && permission.global === true
            );
            console.log("hasSiteSettingsPermission global check:", hasGlobalPermission);
            return hasGlobalPermission;
        }
    
        // Otherwise, normal key check
        const hasPermission = userPermissions.some(permission => permission.value === key);
        console.log("hasSiteSettingsPermission local check:", hasPermission);
        return hasPermission;
    };
    


    return { userPermissions, userData, hasSiteSettingsPermission };
};

export default useUserPermissions;
